import styled from 'styled-components';
import { grey } from 'sushiweb/tokens/color';
import red from 'sushiweb/tokens/color/red';

const getBackgroundColor = props => {
  if (props.disabled) {
    return grey.z400;
  }
  if (props.clear) {
    return 'var(--RED-RED50, #FFF5F6)';
  }
  return red.z500;
};

export const SearchButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => getBackgroundColor(props)};
  width: 6rem;
  height: 4.8rem;
  border-radius: 0 8px 8px 0;
  border: 1px solid
    ${props => (props.clear ? 'var(--RED-RED300, #FFB1C0)' : 'none')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  :hover {
    background-color: ${props =>
      props.disabled ? grey.z400 : !props.clear && red.z600};
  }
  :active {
    background-color: ${props =>
      props.disabled ? grey.z400 : !props.clear && red.z600};
  }
`;
